import { Box } from "@mui/system"
import ButtonMedium1 from "components/elements/ButtonMedium1"
import ContentNormal from "components/elements/ContentNormal"
import Headline2 from "components/elements/Headline2"
import SectionWrapper from "components/layouts/SectionWrapper"
import { AppContext } from "contexts/AppContext"
import { useContext } from "react"
import { useNavigate } from "react-router-dom"

export const PaymentError = () => {
    const navigate = useNavigate()
    const { styleGuide } = useContext(AppContext)

    return (
        <SectionWrapper sx={{minHeight: '60vh'}}>
            <Box sx={{paddingTop: 14}} display={'flex'} flexDirection={'column'} gap={4}>
                <Box display={'flex'} gap={4}>
                    <Headline2
                        translationKey="_PAYMENT_ERROR_"
                        fallbackText="Fejl under betaling"
                        style={{color: styleGuide.color12}}
                    />
                </Box>
                <Box display={'flex'} flexDirection={'column'} gap={4}>
                    <ContentNormal
                        translationKey="_PAYMENT_ERROR_DESCRIPTION_"
                        fallbackText="Der opstod en fejl under betalingen. Du kan gå tilbage til kurven og prøve igen."
                    />
                    <Box>
                        <ButtonMedium1
                            showIcon={false}
                            translationKey="_GO_TO_BASKET_"
                            fallbackText="Gå til kurven"
                            onClick={() => navigate("/basket")}
                        />
                    </Box>
                </Box>
            </Box>
        </SectionWrapper>
    )
}

